var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg188169(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 492.8 492.8",
    style: {
      enableBackground: "new 0 0 492.8 492.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9C6B1"
    },
    d: "M480,230.4H262.4V12.8c0-7.2-8.8-12.8-16-12.8c-7.2,0-16,5.6-16,12.8v217.6H12.8 c-7.2,0-12.8,8.8-12.8,16c0,7.2,5.6,16,12.8,16h217.6V480c0,7.2,8.8,12.8,16,12.8c7.2,0,16-5.6,16-12.8V262.4H480 c7.2,0,12.8-8.8,12.8-16S486.4,230.4,480,230.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C43D27"
    },
    points: "449.6,154.4 409.6,113.6 449.6,73.6 416.8,40.8 376.8,80.8 336,40.8 303.2,73.6 344,113.6  303.2,154.4 336,187.2 376.8,146.4 416.8,187.2 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#991608"
    },
    points: "336,187.2 376.8,146.4 416.8,187.2 449.6,154.4 409.6,113.6 449.6,73.6 416.8,40.8  376.8,80.8  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#07BED6"
    },
    d: "M194.4,376.8c0,41.6-33.6,75.2-75.2,75.2S44,418.4,44,376.8s33.6-75.2,75.2-75.2 C160,300.8,194.4,334.4,194.4,376.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A1AD"
    },
    d: "M172,323.2c29.6,29.6,29.6,77.6,0,107.2s-77.6,29.6-107.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B2AF9A"
    },
    d: "M480,230.4H262.4l-32,32V480c0,7.2,8.8,12.8,16,12.8c7.2,0,16-5.6,16-12.8V262.4H480 c7.2,0,12.8-8.8,12.8-16S486.4,230.4,480,230.4z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg188169);
export default __webpack_public_path__ + "static/media/188169.9f1e2d39290122fa08c883474b6d6609.svg";
export { ForwardRef as ReactComponent };